module.exports = __webpack_public_path__ + "static/media/45.5c56e728.jpg";